export default __webpack_public_path__ + "static/media/handbook-active-icon.249a2127.svg";